import Head from "next/head"
import { usePathname } from 'next/navigation';
import { ReactNode, FC, useState, useEffect } from "react"
import { IMeta } from '../../assets/interfaces/metaInterface'
import imageHelper from "@/src/assets/helpers/imageHelper"
import baseUrl from "@/src/assets/helpers/baseUrl"

type Meta = {
    children: ReactNode
    meta: IMeta | null
    
}

const Meta: FC<Meta> = ({children, meta}) => {
  const [ href, setHref ] = useState('')

  useEffect(() => {
      setHref(window.location.href)
  }, []);

  const path = usePathname()

  return (
    <>
        <Head>
            <title>{meta?.metaTitle ?? 'American Betting Apps'}</title>
            <meta name="description" content={meta?.metaDescription ?? 'AmericanBettingApps.com: Best Sportsbooks and Casino Apps in the U.S.'} />
            <meta property="og:title" content={meta?.metaTitle ?? 'American Betting Apps'} />
            <meta property="og:description" content={meta?.metaDescription ?? 'AmericanBettingApps.com: Best Sportsbooks and Casino Apps in the U.S.'} />
            <meta property="og:type" content="article" />
            <meta property="og:url" content={href} />
            <meta property="og:image" content={(meta && meta.metaImage) ? imageHelper(meta.metaImage).url : undefined} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@OffersBet" />
            <meta name="twitter:creator" content="@Ashstones" />
            <meta name="twitter:image" content={(meta && meta.metaImage) ? imageHelper(meta.metaImage).url : undefined} />
            <meta name="twitter:title" content={meta?.metaTitle ?? 'American Betting Apps'} />
            <meta name="twitter:url" content={href} />
            <meta name="twitter:description" content={meta?.metaDescription ?? 'AmericanBettingApps.com: Best Sportsbooks and Casino Apps in the U.S.'} />
            <meta name="viewport" content="width=device-width, initial-scale=1" /> 
            <meta name="google-site-verification" content="st-DcFjy0scVsi5sQI4kPCLPclZ76cNSSyNg6PRaWwI" />
            <link rel="icon" href="/icon.svg" />
            <link rel="canonical" href={baseUrl(path.slice(1,-1))} />
        </Head>
        {children}
    </>
  )
}

export default Meta